import {Nullable} from '@fl/cmsch-fe-library';

interface IdAndName {
    id: number;
    name: string;
}
/** Selected user and role identifiers used by admin modals. */
export interface UserProfileAndRole {
    /** Currently selected user profile, if any. */
    userProfile: Nullable<IdAndName>;
    /** Currently selected role, if any. */
    role: Nullable<IdAndName>;
}

/** Default empty selection for the shared user/role modal state. */
export const defaultUserProfileAndRoleIds: UserProfileAndRole = {
    role: null,
    userProfile: null,
};
